// extracted by mini-css-extract-plugin
module.exports = {"xs":"0px","sm":"600px","md":"900px","lg":"1200px","xl":"1536px","base":"8px","wrapper":"chevrons_wrapper__qFvx0"};